// extracted by mini-css-extract-plugin
module.exports = {"productFreight":"ProductFreight_productFreight__5yeB_","productFreightContent":"ProductFreight_productFreightContent__tnpzl"};